module.exports = __webpack_public_path__ + "img/member_reservation_area2.d87bf01b.png";